import { parseBooleanValue } from "../../util";
import { IVisibilityLevel } from "../model/VisibilityLevel";

const VisibilityLevelParamMapper = (item: IVisibilityLevel) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid)
  };
};

export default VisibilityLevelParamMapper;
